export default __webpack_public_path__ + "static/media/bnb.d246cd68.svg";